/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Coral_Ox_SpinInputs */

const en_tall_coral_ox_spin = /** @type {(inputs: Tall_Coral_Ox_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const de_tall_coral_ox_spin = /** @type {(inputs: Tall_Coral_Ox_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herunterladen`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Tall_Coral_Ox_SpinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_coral_ox_spin = /** @type {((inputs?: Tall_Coral_Ox_SpinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Coral_Ox_SpinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_coral_ox_spin(inputs)
	return de_tall_coral_ox_spin(inputs)
});